import styled from 'styled-components';
import InputField from '../../../../../../components/FormComponents/InputField';

export const StyledInput = styled(InputField).attrs({
	size: 'small',
	inputProps: {
		style: { fontSize: 14 },
	},
})``;
